import React, { useState, useEffect } from "react";
import { Container, Button, Alert, Row, Col } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import { useUserProfiles } from "../contexts/UserProfileContext";
import { FaGoogle } from "react-icons/fa";
import "./SignIn.css";

function SignIn() {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { user, signInWithGoogle } = useUser();
  const {
    activeProfile,
    profiles,
    isLoading: profilesLoading,
  } = useUserProfiles();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/games";

  useEffect(() => {
    // Only handle navigation after both auth and profiles are loaded
    if (!profilesLoading && user) {
      if (profiles.length === 0) {
        navigate("/create-profile", { replace: true });
      } else if (activeProfile) {
        navigate(from, { replace: true });
      }
    }
  }, [user, activeProfile, profiles, profilesLoading, navigate, from]);

  const handleGoogleSignIn = async () => {
    setError("");
    setIsLoading(true);
    try {
      const result = await signInWithGoogle();
      if (!result.success) {
        setError(result.error);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signin-page">
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col md={8}>
            <h1 className="display-4 mb-4">Welcome to Star Launch</h1>
            <p className="lead">
              Sign in to unlock a personalized gaming experience with multiple
              profiles, custom settings, and cross-device synchronization.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={8} lg={6}>
            <div className="auth-container text-center">
              <h2>Get Started</h2>
              {error && <Alert variant="danger">{error}</Alert>}

              <Button
                variant="light"
                onClick={handleGoogleSignIn}
                disabled={isLoading}
                className="signin-button"
              >
                {isLoading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <>
                    <FaGoogle />
                    <span>Continue with Google</span>
                  </>
                )}
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default SignIn;
